import { kebabCase } from "lodash";
import type { ApDayRange } from "@/accounts-payable/types";
import type { ExportDateField } from "./export-options";

export type InvoiceExportKind = "invoices" | "line_items";

interface ExportDays {
  field: ExportDateField;
  days: ApDayRange | null;
}

/**
 * Named for the days it covers, so saved exports read as a log:
 * "invoices-invoice-date-2026-09-01-to-2026-09-30.csv". Without a range, the
 * day it was taken: "invoices-as-of-2026-10-28.csv".
 */
export const invoiceExportFilename = (
  kind: InvoiceExportKind,
  { field, days }: ExportDays,
  today: string,
) => {
  const span = days
    ? `${kebabCase(field)}-${days.from === days.to ? days.from : `${days.from}-to-${days.to}`}`
    : `as-of-${today}`;
  return `${kind === "invoices" ? "invoices" : "invoice-line-items"}-${span}.csv`;
};

export const saveFile = (file: Blob, filename: string) => {
  const url = URL.createObjectURL(file);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  // Revoked once the click has handed the file to the browser.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
